import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
		{
			path: '/:code',
			name: 'index',
			component: (resolve) => require(['@/views/evaluate'], resolve),
		},
		{
			path: '/s/:code',
			name: 'evaluate',
			component: (resolve) => require(['@/views/evaluate'], resolve),
		},
	]
})
